module.exports = __webpack_public_path__ + "4971318856_effd9bcd81_o.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4971318856_effd9bcd81_o.jpg
// module id = 832
// module chunks = 0